import { ref } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a0b88cb8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "screen-sigin"
};
const _hoisted_3 = {
  class: "screen-items"
};
const _hoisted_4 = {
  class: "cn"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "中文备注", -1));
const _hoisted_6 = {
  key: 0,
  class: "en"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "英文备注", -1));
const _hoisted_8 = {
  class: "footer"
};
const _hoisted_9 = {
  class: "btn-box"
};
const _hoisted_10 = {
  key: 1,
  class: "screen-sigins"
};
const _hoisted_11 = {
  class: "head"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "left"
  }
}, "中文备注", -1));
const _hoisted_14 = {
  key: 0,
  style: {
    "text-align": "left"
  }
};
const _hoisted_15 = {
  class: "items-id"
};
const _hoisted_16 = {
  class: "cn",
  style: {
    "margin-right": "18px"
  }
};
const _hoisted_17 = {
  key: 0,
  class: "en"
};
const _hoisted_18 = {
  class: "footer"
};
const _hoisted_19 = {
  class: "btn-box"
};
const _hoisted_20 = {
  key: 2,
  class: "screen-content"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "上传1条备注", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-title"
}, "所有商品共用该备注", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "上传多条备注", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-title"
}, "每个商品对应不同备注", -1));
import { translateRemark, submitRemark } from '@/api/goodsInfo';
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'RemarksModal',
  props: {
    dbtId: null,
    modalVisible: {
      type: Boolean
    },
    selectedRowKeys: null,
    prodChnl: null
  },
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const siginMark = ref(false); // 单条备注
    const muteMark = ref(false); // 多条备注
    const selectedList = ref([]); // 选中的商品列表
    const screenshotReqVos = ref([]); // 备注翻译列表
    const spinning = ref(false); // 翻译 loading
    const upMark = flag => {
      if (flag === 0) {
        siginMark.value = true;
        screenshotReqVos.value = selectedList.value.map(item => {
          return {
            zhHans: '',
            enUs: '',
            id: item.id,
            prodId: item.prodId,
            prodType: item.prodType
          };
        });
      } else {
        muteMark.value = true;
        screenshotReqVos.value = selectedList.value.map(item => {
          return {
            zhHans: '',
            enUs: '',
            id: item.id,
            prodId: item.prodId,
            prodType: item.prodType
          };
        });
      }
    }; // 上传
    const translate = async () => {
      try {
        spinning.value = true;
        const params = {
          remarkTranslates: screenshotReqVos.value.map(item => {
            return {
              ...item,
              zhHans: siginMark.value ? screenshotReqVos.value[0].zhHans : item.zhHans
            };
          })
        };
        const res = await translateRemark(params);
        if (res.code == 0) {
          screenshotReqVos.value = res.data.remarkTranslatedResult;
        }
      } catch (error) {} finally {
        spinning.value = false;
      }
    }; // 翻译
    const submitUpload = async () => {
      try {
        spinning.value = true;
        const params = {
          dbtId: selectedList.value[0].dbtId,
          prodChnl: props.prodChnl,
          screenshotReqVos: screenshotReqVos.value.map(item => {
            return {
              ...item,
              zhHans: siginMark.value ? screenshotReqVos.value[0].zhHans : item.zhHans,
              enUs: siginMark.value ? screenshotReqVos.value[0].enUs : item.enUs
            };
          })
        };
        const res = await submitRemark(params);
        if (res.code == 0) {
          if (res.data.failProdIds.length > 0) {
            let str = '';
            res.data.failProdIds.forEach(item => {
              // 换行
              str += item + '\n';
            });
            message.error(str + '上传失败');
          } else {
            message.success('上传成功');
            spinning.value = false;
            emit('searchData');
            closeModal();
          }
        } else {
          message.error(res.msg);
        }
      } catch (e) {} finally {
        spinning.value = false;
      }
    }; // 提交备注
    const openModal = data => {
      selectedList.value = data;
    };
    const closeModal = () => {
      if (spinning.value) return;
      emit('update:modalVisible', false);
      selectedList.value = [];
      siginMark.value = false;
      muteMark.value = false;
      screenshotReqVos.value = [];
      spinning.value = false;
    };
    expose({
      openModal
    });
    return (_ctx, _cache) => {
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.modalVisible,
        centered: "",
        title: "上传备注",
        width: siginMark.value || muteMark.value ? '1000px' : '800px',
        maskClosable: false,
        footer: false,
        onCancel: closeModal
      }, {
        default: _withCtx(() => [_createVNode(_component_a_spin, {
          spinning: spinning.value
        }, {
          default: _withCtx(() => [siginMark.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedList.value, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index
            }, _toDisplayString(item.prodId), 1);
          }), 128))]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_textarea, {
            value: screenshotReqVos.value[0].zhHans,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => screenshotReqVos.value[0].zhHans = $event),
            placeholder: "请输入审核备注...",
            rows: 9,
            maxlength: props.prodChnl == 'apple' ? 400 : 200
          }, null, 8, ["value", "maxlength"])]), __props.prodChnl == 'apple' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_textarea, {
            value: screenshotReqVos.value[0].enUs,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => screenshotReqVos.value[0].enUs = $event),
            placeholder: "请输入审核备注...",
            rows: 9
          }, null, 8, ["value"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [__props.prodChnl == 'apple' ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "trans",
            onClick: translate
          }, [_createVNode(_component_svg_icon, {
            "icon-class": "trans",
            class: "trans",
            style: {
              "width": "14px",
              "height": "12px"
            }
          }), _createTextVNode(" 智能翻译 ")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createVNode(_component_a_button, {
            onClick: closeModal,
            style: {
              "margin-right": "12px"
            },
            loading: spinning.value
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }, 8, ["loading"]), _createVNode(_component_a_button, {
            type: "primary",
            onClick: submitUpload,
            loading: spinning.value
          }, {
            default: _withCtx(() => [_createTextVNode("提交")]),
            _: 1
          }, 8, ["loading"])])])])) : muteMark.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _hoisted_13, __props.prodChnl == 'apple' ? (_openBlock(), _createElementBlock("div", _hoisted_14, "英文备注")) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedList.value, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "screen-sigins-item",
              key: index
            }, [_createElementVNode("div", _hoisted_15, _toDisplayString(item.prodId), 1), _createElementVNode("div", _hoisted_16, [_createVNode(_component_a_input, {
              value: screenshotReqVos.value[index].zhHans,
              "onUpdate:value": $event => screenshotReqVos.value[index].zhHans = $event,
              placeholder: "请输入审核备注...",
              maxlength: props.prodChnl == 'apple' ? 400 : 200
            }, null, 8, ["value", "onUpdate:value", "maxlength"])]), __props.prodChnl == 'apple' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_a_input, {
              value: screenshotReqVos.value[index].enUs,
              "onUpdate:value": $event => screenshotReqVos.value[index].enUs = $event,
              placeholder: "请输入审核备注..."
            }, null, 8, ["value", "onUpdate:value"])])) : _createCommentVNode("", true)]);
          }), 128)), _createElementVNode("div", _hoisted_18, [__props.prodChnl == 'apple' ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "trans",
            onClick: translate
          }, [_createVNode(_component_svg_icon, {
            "icon-class": "robot",
            style: {
              "width": "14px",
              "height": "12px",
              "vertical-align": "baseline"
            },
            "class-name": "robot-icon"
          }), _createTextVNode(" 智能翻译 ")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [_createVNode(_component_a_button, {
            onClick: closeModal,
            style: {
              "margin-right": "12px"
            },
            loading: spinning.value
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }, 8, ["loading"]), _createVNode(_component_a_button, {
            type: "primary",
            onClick: submitUpload,
            loading: spinning.value
          }, {
            default: _withCtx(() => [_createTextVNode("提交")]),
            _: 1
          }, 8, ["loading"])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", {
            class: "upload-screen-img",
            onClick: _cache[2] || (_cache[2] = $event => upMark(0))
          }, [_createVNode(_component_svg_icon, {
            "icon-class": "remark",
            "class-name": "remark-icon"
          }), _hoisted_21, _hoisted_22]), _createElementVNode("div", {
            class: "upload-screen-img",
            onClick: _cache[3] || (_cache[3] = $event => upMark(1))
          }, [_createVNode(_component_svg_icon, {
            "icon-class": "remarks",
            "class-name": "remark-icon"
          }), _hoisted_23, _hoisted_24])]))]),
          _: 1
        }, 8, ["spinning"])]),
        _: 1
      }, 8, ["open", "width"]);
    };
  }
});